/**
 * Hides most of an email's local part, e.g. "jane.doe@example.com" becomes
 * "j•••@example.com". Surrounding whitespace is trimmed; input with no local
 * part is returned trimmed but otherwise unchanged.
 */
export function maskEmail(email: string) {
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf('@');
  if (at < 1) {
    return trimmed;
  }
  // Spread by code point so a leading emoji or astral character isn't split
  const [first] = [...trimmed.slice(0, at)];
  return `${first}•••${trimmed.slice(at)}`;
}
